<app-expansion-panel i18n-title title="Information du contrat">
  <div expansionPanelHeaderActions>
    @if (proposal.proposalState === 'POLICY_CREATED') {
      <app-update-policy-modal
        #updatePolicyModal
        (policyUpdated)="refreshTaskDetails()"
      />
      <div class="task-details__proposals-header">
        <button
          type="button"
          class="lty-btn lty-btn-white d-flex align-items-center gap-1"
          (click)="updatePolicyModal.openModal(proposal)"
        >
          <ng-container i18n>Modifier les informations</ng-container>
        </button>
      </div>
    } @else {
      <app-add-proposal-modal
        #addProposalModal
        [leadId]="proposal?.leadDetails?.leadId"
        [disableNavigation]="true"
        [preload]="false"
        (proposalAdded)="refreshTaskDetails()"
      />
      <div class="task-details__proposals-header">
        <button
          type="button"
          class="lty-btn lty-btn-white d-flex align-items-center gap-1"
          (click)="addProposalModal.openModal(proposal)"
        >
          <ng-container i18n>Modifier les informations</ng-container>
        </button>
      </div>
    }
  </div>
  <div class="d-flex flex-column gap-2 mt-12">
    <div class="d-flex gap-2">
      <div class="flex-grow-1">
        <app-card class="task-user-profile-info__left">
          <div cardRows class="card__rows">
            <div class="card__row">
              <span class="card__label" i18n>Date de début</span>
              <span class="card__value">{{
                proposal?.policyDetails?.startDate | date: DATE_FORMAT
              }}</span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Date de fin</span>
              <span class="card__value">{{
                proposal?.policyDetails?.endDate | date: DATE_FORMAT
              }}</span>
            </div>

            @if (proposal?.offerSignatureDate) {
              <div class="card__row">
                <span class="card__label" i18n
                  >Date de signature de l'offre</span
                >
                <span class="card__value">{{
                  proposal.offerSignatureDate | date: DATE_FORMAT
                }}</span>
              </div>
            }

            <div class="card__row">
              <span class="card__label" i18n>Type d'assurance</span>
              <span class="card__value">{{
                getInsuranceTypeLabel(proposal.insuranceType)
              }}</span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Compagnie d'assurance</span>
              <span class="card__value">
                <ng-container
                  *ngIf="
                    lngCode === 'en' ||
                      !proposal?.policyDetails?.categoryDetails
                        ?.categoryNameInFrench;
                    else frCompany
                  "
                  >{{
                    proposal?.policyDetails?.categoryDetails?.categoryName
                  }}</ng-container
                >
                <ng-template #frCompany>{{
                  proposal?.policyDetails?.categoryDetails?.categoryNameInFrench
                }}</ng-template></span
              >
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Produit d'assurance</span>
              <span class="card__value">
                <ng-container
                  *ngIf="
                    lngCode === 'en' ||
                      !proposal?.policyDetails?.categoryDetails
                        ?.subCategoryNameInFrench;
                    else frProduct
                  "
                  >{{
                    proposal?.policyDetails?.categoryDetails?.subCategoryName
                  }}</ng-container
                >
                <ng-template #frProduct>{{
                  proposal?.policyDetails?.categoryDetails
                    ?.subCategoryNameInFrench
                }}</ng-template>
              </span>
            </div>
          </div>
        </app-card>
      </div>
      <div class="flex-grow-1">
        <app-card class="task-user-profile-info__left">
          <div cardRows class="card__rows">
            @if (proposal?.policyDetails?.policyId) {
              <div class="card__row">
                <span class="card__label" i18n>N° police</span>
                <span class="card__value">{{
                  proposal.policyDetails.policyId
                }}</span>
              </div>
            }
            <div class="card__row">
              <span class="card__label" i18n>Montant de la prime</span>
              <span class="card__value">{{
                proposal?.policyDetails?.premiumAmount | currency: 'CHF'
              }}</span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Fréquence de paiement</span>
              <span class="card__value">{{
                getPeriodicityLabel(proposal?.policyDetails?.periodicity!)
              }}</span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Couverture</span>
              <span class="card__value">
                <app-proposal-products
                  [productDetailsList]="
                    proposal?.policyDetails?.productDetails?.productList
                  "
                />
              </span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Montant total</span>
              <span class="card__value">{{
                proposal?.policyDetails?.totalAmount | currency: 'CHF'
              }}</span>
            </div>
            @if (proposal.signatureType) {
              <div class="card__row">
                <span class="card__label" i18n>Signature</span>
                <span class="card__value"
                  ><ng-container i18n>Signé </ng-container
                  >{{ getSignatureTypeLabel(proposal?.signatureType) }}</span
                >
              </div>
            }
          </div>
        </app-card>
      </div>
    </div>

    <app-policy-acceptation-message class="d-block mt-12" />
  </div>
</app-expansion-panel>
